<template>
  <a
    :href="formatMail(email)"
    :title="email"
    target="_blank">
    <svg-icon name="mail"/>
  </a>
</template>

<script>
export default {
  props: ['email'],
  methods: {
    formatMail: (email) => 'mailto:' + email
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailLink.vue